import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logo entreprise.png";


const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [loadingHome, setLoadingHome] = useState(false);
  const handleHomeClick = () => {
  setLoadingHome(true);

  setTimeout(() => {
    setLoadingHome(false);
    navigate("/");
  }, 2000);
};

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const getLinkClass = (path: string) => {
    const isActive = location.pathname === path;
    return `block py-2 px-3 rounded md:p-0 cursor-pointer transition-colors duration-200 font-semibold text-base tracking-wide ${
      isActive
        ? "text-white bg-blue-700 md:bg-transparent md:text-blue-700"
        : "text-gray-900 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-blue-700 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent"
    }`;
  };
  if (loadingHome) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
      <img
        src={logo}
        className="h-20 w-auto animate-[fadeInZoom_1.2s_ease-in-out]"
        alt="loading"
      />
    </div>
  );
}

  return (
    
    <nav className="bg-white dark:bg-gray-900 fixed w-full z-20 top-10 start-0 border-b border-gray-200 dark:border-gray-600">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <Link
          to="/"
          className="flex items-center space-x-3 rtl:space-x-reverse"
          onClick={() => window.location.reload()}
        >
          <img src={logo} className="h-16 w-32 ml-10" alt="JTRONICS Logo" />
        </Link>
        <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse">
          <button
            data-collapse-toggle="navbar-sticky"
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
            aria-controls="navbar-sticky"
            aria-expanded={isMenuOpen ? "true" : "false"}
            onClick={toggleMenu}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
        </div>
        <div
          className={`items-center justify-between w-full md:flex md:w-auto md:order-1 ${
            isMenuOpen ? "block" : "hidden"
          }`}
          id="navbar-sticky"
        >
          <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-12 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
            <li>
              <Link
  to="/"
  className={getLinkClass("/")}
  onClick={(e) => {
    e.preventDefault();
    toggleMenu();
    handleHomeClick();
  }}
>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M11.47 3.84a.75.75 0 011.06 0l8.69 8.69a.75.75 0 101.06-1.06l-8.689-8.69a2.25 2.25 0 00-3.182 0l-8.69 8.69a.75.75 0 001.061 1.06l8.69-8.69z" />
                  <path d="M12 5.432l8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 01-.75-.75v-4.5a.75.75 0 00-.75-.75h-3a.75.75 0 00-.75.75V21a.75.75 0 01-.75.75H5.625a1.875 1.875 0 01-1.875-1.875v-6.198a2.29 2.29 0 00.091-.086L12 5.43z" />
                </svg>
              </Link>
            </li>
            <li>
  <Link
    to="/qui-sommes-nous"
    className={getLinkClass("/qui-sommes-nous")}
    onClick={toggleMenu}
  >
    Qui sommes-nous ?
  </Link>
</li>
            <li>
              <Link to="/produits" className={getLinkClass("/produits")} onClick={toggleMenu}>
                Nos Produits
              </Link>
            </li>
            <li>
  <Link
    to="/lavage-professionnel"
    className={getLinkClass("/lavage-professionnel")}
    onClick={toggleMenu}
  >
    Lavage professionnel
  </Link>
</li>
            <li>
              <Link to="/nos-projets" className={getLinkClass("/nos-projets")} onClick={toggleMenu}>
                Let's Wash Parks
              </Link>
            </li>
            <li>
              <Link to="/clean-pressing" className={getLinkClass("/clean-pressing")} onClick={toggleMenu}>
                Laverie self-service
              </Link>
            </li>
            <li>
  <Link
    to="/contact"
    className={getLinkClass("/contact")}
    onClick={toggleMenu}
  >
    Contact
  </Link>
</li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;